var _style, _line, _line2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#CFCFCF;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st1{fill:#6325A5;}\n\t.st2{fill:#BC31A2;}\n\t.st3{fill:#41D8A6;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 68.7,
    y1: 194.8,
    x2: 146,
    y2: 194.8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 146,
    y1: 140.3,
    x2: 68.7,
    y2: 140.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 140.3,
    y: 49.3,
    className: "st1",
    width: 56,
    height: 56
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 196.3,
    y: 49.3,
    className: "st2",
    width: 75.7,
    height: 56
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 410.3,
    className: "st1",
    width: 55.3,
    height: 56
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 168.3,
    y: 410.3,
    className: "st2",
    width: 82.2,
    height: 56
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 410.3,
    className: "st3",
    width: 76.3,
    height: 56
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 467,
    y: 320,
    className: "st3",
    width: 45,
    height: 56
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 413,
    y: 320,
    className: "st1",
    width: 54,
    height: 56
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 331.3,
    y: 320,
    className: "st3",
    width: 81.7,
    height: 56
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 320,
    className: "st2",
    width: 55.3,
    height: 56
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 320,
    className: "st3",
    width: 51,
    height: 56
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 320,
    className: "st1",
    width: 51,
    height: 56
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 320,
    className: "st2",
    width: 82,
    height: 56
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 320,
    className: "st3",
    width: 51,
    height: 56
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 62.4,
    y: 229.8,
    className: "st3",
    width: 77.9,
    height: 56
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    y: 139.5,
    className: "st1",
    width: 68.7,
    height: 56
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 139.5,
    className: "st3",
    width: 136,
    height: 56
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 282,
    y: 139.5,
    className: "st1",
    width: 77.3,
    height: 56
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 359.3,
    y: 139.5,
    className: "st2",
    width: 53.7,
    height: 56
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 303.3,
    y: 49.3,
    className: "st3",
    width: 56,
    height: 56
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 413,
    y: 139.5,
    className: "st3",
    width: 54,
    height: 56
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 467,
    y: 139.5,
    className: "st2",
    width: 45,
    height: 56
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 165.4,
    y: 229.8,
    className: "st2",
    width: 54.6,
    height: 56
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 229.8,
    className: "st1",
    width: 76,
    height: 56
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 320.6,
    y: 229.8,
    className: "st2",
    width: 76,
    height: 56
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.45e78f07b7962947ef4ceaa9a560e616.svg";
export { ForwardRef as ReactComponent };